<script>
  import { onMount } from "svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import Table from "../../../../Shared/Table/table.svelte"
  import notify from "../../../../Script/notify"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import Filter from "../../../../Shared/filter.svelte"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import DocTempList from "../../../Publish/SinglePublish/pages/DocTempList.svelte"
  import { createEventDispatcher } from "svelte"
  import { getRequest } from "../../../../Script/apiMethods"
  const dispatch = createEventDispatcher()

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = true

  /**
   * @type {String} - massage for loading screen
   */
  let msg = "Fetching Email templates"

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {noDocumentTemplateNotify} - document template not selected notification
   */
  let noDocumentTemplateNotify = {
    close() {},
  }

  /**
   * @type {documentTemplateErrorNotify} - selected document template get method error notofication
   */
  let documentTemplateErrorNotify = {
    close() {},
  }

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @typedef {Object} search - it contains what user want to search (searchvalue) in which parameter (searchParam)
   * @type {Object}
   * it contains what user want to search (searchvalue) in which parameter (searchParam)
   *
   * @property {String} searchvalue - what value need to search.
   * @property {String} searchParam - on which param need to show
   */
  let search = {
    searchParam: "name",
    searchvalue: "",
  }

  /**
   * @type {String} - from date of filter list
   */
  let startDate = null

  /**
   * @type {String} - to date of filter list
   */
  let endDate = null

  /**
   * @type {Object} - it consists response of document template fetch api
   */
  let emailData = {}

  /**
   * @type {Object} - user selected document temaplate details stored this variable
   */
  let selectedTemp = {}
  let sortBy

  onMount(async () => {
    try {
      apiCallBtnDisable = true

      //fetch table filter details in the qurey
      query = queryStringToJSON($querystring)
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      if (query.sdate) startDate = query.sdate
      if (query.edate) endDate = query.edate
      if (query.sname) search.searchvalue = query.sname

      emailData = await fetchTemplates()
      push(`/analytics/documents/send-email?id=${query.id}${query.aliasId ? `&aliasId=${query.aliasId}` : ``}&limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)
    } catch (error) {
      const info = "PAGE: Compose Email - Email Selection\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  })

  /**
   * @description Fetches the list of document templates.
   */
  const fetchTemplates = async () => {
    try {
      // Fetching list of document templates
      const data = await getRequest(`/api/swagger/v2/templates/emails?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      // show email templates by filtering only when they have name
      return data
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Function to fetch templates based on user input.
   */
  const whileChangingEntries = async (e) => {
    try {
      apiCallBtnDisable = true
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      emailData = await fetchTemplates()
      push(`/analytics/documents/send-email?id=${query.id}${query.aliasId ? `&aliasId=${query.aliasId}` : ``}&limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)
    } catch (error) {
      const info = "PAGE: Compose Email - Email Selection\nEVENT: While changing email list"
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      apiCallBtnDisable = true
      limit = 10
      page = 1
      sort = -1
      search.searchvalue = ""
      startDate = null
      endDate = null
      emailData = await fetchTemplates()
      push(`/analytics/documents/send-email?id=${query.id}${query.aliasId ? `&aliasId=${query.aliasId}` : ``}&limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)
    } catch (error) {
      const info = "PAGE: Compose Email - Email Selection\nEVENT: while resetting the filtered email list."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  const findSelectedTemplate = (json) => {
    selectedTemp = emailData.templates.filter((email) => email.id == json.id)[0]
    push(`/analytics/documents/send-email?id=${query.id}${query.aliasId ? `&aliasId=${query.aliasId}` : ``}&email=${selectedTemp.id}`)
    dispatch("emailSelect", selectedTemp.id)
  }
</script>

<svelte:head>
  <title>Select Email Template</title>
</svelte:head>

<div class="mx-auto w-full pt-6 md:w-4/5 xl:w-3/5">
  <button
    on:click={() => {
      push(`/analytics/documents/send-email?id=${query.id}${query.aliasId ? `&aliasId=${query.aliasId}` : ``}`)
      dispatch("back")
    }}
    type="button"
    style="text-decoration: none;"
    class="mb-1 hidden w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500 sm:mb-0 md:block"
  >
    <span>
      <i class="fa-solid fa-reply" />
      <span>&nbsp;Back&nbsp;</span>
    </span>
  </button>
</div>
<div class="mx-auto w-full md:w-4/5 xl:w-3/5">
  <div class="flex flex-col items-center justify-between gap-0 mobile:gap-3 md:flex-row">
    <div class="mx-auto mt-3 flex flex-col items-center justify-center mobile:mt-0 md:ml-0 md:items-start lg:mx-0">
      <div class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Choose Email Template</div>
    </div>
    <div class="mt-3 flex items-center justify-center gap-3 md:mt-0">
      <div data-tooltip="Back to List" tooltip-position="top" class="block md:hidden">
        <button
          type="button"
          on:click={() => {
            if (query.aliasId) push(`/documents/single/secure_access?id=${query.id}`)
            else push(`/analytics/documents/single?id=${query.id}`)
          }}
          class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-full border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 no-underline hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 dark:bg-lightgray dark:text-white dark:hover:bg-blue-600"
        >
          <i class="fa-solid fa-reply" />
        </button>
      </div>
    </div>
  </div>
</div>

<div class="mx-auto h-auto w-full px-6 pb-40 pt-6 md:w-4/5 md:px-0 xl:w-3/5">
  <div class="relative flex min-h-[470px] flex-col justify-between rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
    <p class="mb-3 w-full select-none break-words text-justify text-sm text-gray-200 mobile:text-base sm:w-3/4 md:text-base">Please select a email template from which metadata will be imported. This will help you save time by automatically populating certain fields with pre-existing data from the selected template.</p>
    <div class="h-full space-y-3">
      {#if selectedTemp.id}
        <div class="flex h-full items-center justify-center">
          <button class="group relative mx-auto my-auto mt-3 flex h-full w-full flex-col gap-3 rounded-md bg-[#f7f7f7] px-6 py-3 hover:shadow-md dark:border-2 dark:border-blue-500 dark:border-transparent dark:bg-bodyblack">
            <div class="flex w-full flex-col items-center justify-between gap-3 mobile:flex-row sm:gap-6">
              <div class="sm:5/12 w-full space-y-1.5">
                <p class="text-start text-sm font-semibold text-blue-500 sm:text-lg">{selectedTemp.name}</p>
                <p class="truncate text-start text-xs font-medium text-gray-800 dark:text-gray-200 sm:text-base">{selectedTemp.id}</p>
              </div>
              <div class="sm:7/12 flex w-full select-none justify-start mobile:justify-end">
                <p class="font select-none text-start text-xs font-normal text-gray-800 dark:text-gray-200 sm:text-base">
                  <i class="fa-solid fa-calendar-days" />
                  &nbsp;&nbsp;{new Date(selectedTemp.created || selectedTemp.dateCreated).toString().slice(0, 24)}
                </p>
              </div>
            </div>
          </button>
        </div>
      {:else if !selectedTemp.id}
        {#if emailData.templates}
          <Table on:changeEntries={whileChangingEntries} on:resetEntries={resetList} title={"Email Templates"} filterComponent={Filter} filter={true} jsonData={emailData.templates ? emailData.templates : []} count={emailData.count}>
            <!-- List component -->
            {#if emailData.templates.length}
              {#each emailData.templates as Json}
                <DocTempList json={Json} on:click={() => findSelectedTemplate(Json)} />
              {/each}
            {:else}
              <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no Email template</div>
            {/if}
          </Table>
        {/if}
      {/if}
    </div>
    {#if selectedTemp.id}
      <div class="mt-3 flex items-center justify-end gap-3">
        <button
          on:click={() => {
            selectedTemp = {}
          }}
          type="button"
          class="{!selectedTemp.id ? 'cursor-not-allowed bg-yellow-300 hover:bg-yellow-400 active:bg-yellow-200' : 'bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-500'} flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] px-2 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4"
        >
          <i class="fa-solid fa-rotate-left" />
          <span class="select-none md:block">&nbsp;&nbsp;Change Template&nbsp;</span>
        </button>
        <button
          on:click={() => {
            push(`/analytics/documents/send-email?id=${query.id}${query.aliasId ? `&aliasId=${query.aliasId}` : ``}&email=${selectedTemp.id}`)
            dispatch("emailSelect", selectedTemp.id)
          }}
          type="button"
          class="flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300 md:w-32 lg:px-4"
        >
          <i class="fa-solid fa-check" />
          <span class="select-none md:block">&nbsp;&nbsp;Confirm&nbsp;</span>
        </button>
      </div>
    {/if}
    {#if apiCallBtnDisable}
      <LoadingScreen {msg} />
    {/if}
  </div>
</div>
